/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import PageLayout from "examples/LayoutContainers/PageLayout";
import { Theme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import Footer from "layouts/authentication/components/Footer";
import Grid from "@mui/material/Grid";

// Images
import bgImage from "assets/images/404.jpeg";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

function NotFound(): JSX.Element {
  const homepage = () => {
    navigate("/horses");
  };
  let navigate = useNavigate();

  return (
    <PageLayout>
      <MDBox
        width="100%"
        pt={"20%"}
        pb={"10%"}
        sx={{
          backgroundImage: ({
            functions: { linearGradient, rgba },
            palette: { gradients },
          }: Theme) => bgImage && `url(${bgImage})`,
          backgroundSize: "cover",
          overflow: "hidden",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Grid container spacing={3} justifyContent="center">
          <Grid item xs={12}>
            <MDTypography variant="h1" align="center" fontWeight="bold" color="white">
              Error 404
            </MDTypography>
          </Grid>
          <Grid item xs={12}>
            <MDTypography variant="h3" align="center" fontWeight="medium" color="white">
              Erm. Page not found
            </MDTypography>
          </Grid>
          <Grid item xs={12}>
            <MDTypography variant="h6" align="center" fontWeight="regular" color="white">
              We suggest you go to the homepage while we solve this issue.
            </MDTypography>
          </Grid>
          <Grid item xs={12}>
            <div style={{ margin: "auto", textAlign: "center" }}>
              <MDButton variant="gradient" color="light" onClick={homepage} width="200px">
                Go to Homepage
              </MDButton>
            </div>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </PageLayout>
  );
}

export default NotFound;
